import { render } from "./WCSelectBox.vue?vue&type=template&id=55403690&scoped=true"
import script from "./WCSelectBox.vue?vue&type=script&lang=js"
export * from "./WCSelectBox.vue?vue&type=script&lang=js"

import "./WCSelectBox.vue?vue&type=style&index=0&id=55403690&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55403690"]])

export default __exports__